
export default function CropWithUploadCare(url, cropW, cropH, resizeW, resizeH) {
    var proxy = "https://befe7f4528284b5c01f9.ucr.io/" +
    (typeof (cropW && cropH) != 'undefined' ? '-/crop/' + cropW + 'x' + cropH + '/' : '') +
    (typeof (resizeW) != 'undefined' ? ('-/resize/' + resizeW + 'x' + (resizeH ? resizeH : '') + '/' ) : '')  +
        url;
    return proxy;
};